export default "__VITE_ASSET__CXBjsMmI__"